import React, { useContext, useEffect, useState } from "react";
// mui
import { Grid2, Tooltip } from "@mui/material";
//styling
import styles from "./DomainHosted.module.scss";
// local import
import SiteHeaderCard from "../../Components/HeaderComponent/Header";
import PageLoading from "../../../../../../GlobalComponents/PageLoading/PageLoading";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  adminApi,
  formatFilename,
  getApproximateDaysUntilTimestamp,
  lastSegmentPath,
  Regex,
  STAGING,
  verifyEmail,
} from "../../../../../../Utils/roconConstants";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";

import {
  getStagingEnv,
  siteDetails,
  staging,
} from "../../../../../../Utils/sitePages";
import Dns from "./SubPages/Dns";
import WpOptions from "./SubPages/WpOptions";
import axios from "axios";
import DomainTable from "./Components/DomainTable";
import { ActivatePopup } from "../../../../../../Utils/activatePopup";
import { useMakeApiCalls } from "../../../../../../Hooks/useMakeApiCalls";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { AddDomain } from "./SubPages/AddDomain/AddDomain";
import { useEmailId } from "../../../../../../Utils/utils";
import { ReactComponent as PROCESSING } from "../../../../../../GlobalAssets/svg/PROCESSING.svg";
import { ReactComponent as SUCCESS } from "../../../../../../GlobalAssets/svg/SUCCESS.svg";

export default function DomainHosted() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [popupCard, setPopupCard] = useState("");
  const [domainName, setDomainName] = useState(null);
  const [domainError, setDomainError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [privateKeyError, setPrivateKeyError] = useState(false);
  const [certificateChainError, setCertificateChainError] = useState(false);

  const [sslAuto, setSslAuto] = useState(false);
  const [sslAuthChallenge, setSSLAuthChallenge] = useState();
  const [tos, setTos] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showReadyPage, setShowReadyPage] = useState(false);
  const [showFailedPage, setShowFailedPage] = useState(false);
  const [showPointYourDomain, setShowPointYourDomain] = useState(false);
  const [domainAPI, setDomainAPI] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });
  const [installing, setInstalling] = useState(false);
  const [failedMessage, setFailedMessage] = useState("");
  const [dnsVerified, setDnsVerified] = useState(false);
  const [dnsChecking, setDnsChecking] = useState(false);
  const [ebsDomains, setEbsDomains] = useState([]);

  const [ssldata, setSslData] = useState({
    privateKey: "",
    certificateChain: "",
  });

  const [sslAutoData, setSSLAutoData] = useState({
    email: "",
    domainName: "",
  });

  const [selectedDomain, setSelectedDomain] = useState({
    domaName: "",
    domainId: null,
  });

  const [sslAutoDataErr, setSSLAutoDataErr] = useState({
    email: false,
    domainName: false,
  });

  const [cardStatus, setCardStatus] = useState({
    title: "Auto SSL",
    value: "AutoSSL",
  });

  const [searchParams] = useSearchParams();

  const sslAutoUrl = process.env.REACT_APP_SSL_AUTO_URL;
  const params = useParams();
  const siteId = params.siteId;
  const orgId = params.orgId;

  let sites = useSelector((state) => state?.sitesInfo?.selectedSite);
  let sitesInfo = useSelector((state) => state?.sitesInfo);
  let arnInfo = sitesInfo.siteArns || {};
  let organizationsInfo = useSelector(
    (state) => state.organizationsInfo.selectedOrg,
  );
  let userId = useSelector((state) => state?.users?.userDetails?.userId);
  const selectedDomainsite = useSelector(
    (state) => state.sitesInfo.selectedDomain,
  );
  const isStaging = staging(sites);
  const isEbsSite =
    sites?.ebsSite === true && String(sites?.siteId) === String(siteId);

  // v2 sites get their certificate from AWS: no "add-ssl" step
  const validSteps = isEbsSite
    ? ["domain-details", "point-your-domain"]
    : ["domain-details", "point-your-domain", "add-ssl"];
  const isAddDomainPage = validSteps.includes(searchParams.get("status"));

  const siteData = siteDetails(sites);

  let livedom = siteData?.domain.find((item) => item.primary === "Y")?.name;

  const { domaName, domainId } = selectedDomain;

  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  const emailId = useEmailId();

  const isDedicated = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated,
  );

  // v2: the rows from ACM (validation record, certificate expiry, CNAME target); the DNS
  // check runs when the user clicks Next (verifyEbsDns)
  const loadEbsDomains = (onDone = () => {}) => {
    getStore().dispatch({
      type: Actions.API_EBS_SITE_DOMAINS,
      data: { siteId },
      meta: {
        onSuccess: (data) => {
          setEbsDomains(Array.isArray(data) ? data : []);
          onDone();
        },
        onError: () => onDone(),
      },
    });
  };
  const ebsDomainOf = (domainId) =>
    ebsDomains.find((d) => String(d.domainId) === String(domainId));
  const ebsDomain = ebsDomainOf(selectedDomain.domainId);

  const verifyEbsDns = (onDone) => {
    setDnsChecking(true);
    getStore().dispatch({
      type: Actions.API_CHECK_DNS_STATUS,
      data: { domain: ebsDomain.validationName, ip: ebsDomain.validationValue },
      meta: {
        onSuccess: (data) => {
          const verified =
            ebsDomain.validationStatus === "SUCCESS" || data?.status === true;
          setDnsVerified(verified);
          setDnsChecking(false);
          onDone(verified);
        },
        onError: () => {
          setDnsVerified(false);
          setDnsChecking(false);
          onDone(false);
        },
      },
    });
  };

  const checkDnsStatus = () => {
    if (isEbsSite) {
      loadEbsDomains();
      return;
    }
    const domain = selectedDomain.domaName || domainName;
    const targetIp = isDedicated ? siteData?.instanceIp : siteData?.ipAddress;
    if (!domain || !targetIp) return;

    setDnsChecking(true);
    getStore().dispatch({
      type: Actions.API_CHECK_DNS_STATUS,
      data: { domain, ip: targetIp },
      meta: {
        onSuccess: (data) => {
          setDnsVerified(data?.status === true);
          setDnsChecking(false);
        },
        onError: () => {
          setDnsVerified(false);
          setDnsChecking(false);
        },
      },
    });
  };

  useEffect(() => {
    if (step !== 2) {
      setDnsVerified(false);
      return;
    }
    // v2: once the ACM record is there nothing is polled; DNS is checked on Next
    if (isEbsSite && ebsDomain?.validationName) return;
    checkDnsStatus();
    const interval = setInterval(checkDnsStatus, 30000);
    return () => clearInterval(interval);
  }, [step, selectedDomain.domaName, domainName, isEbsSite, ebsDomain?.validationName]);

  useEffect(() => {
    if (isEbsSite && !isAddDomainPage) loadEbsDomains();
  }, [isEbsSite, isAddDomainPage]);

  const ebsDomainPending = siteData?.domain?.some(
    (d) => d.status === "IN_PROGRESS",
  );

  useEffect(() => {
    if (!isEbsSite || isAddDomainPage || !ebsDomainPending) return;
    const interval = setInterval(() => {
      getStore().dispatch({
        type: Actions.API_GET_SELECTED_SITE_DETAILS,
        data: { siteId: siteId },
      });
    }, 30000);
    return () => clearInterval(interval);
  }, [isEbsSite, isAddDomainPage, ebsDomainPending, siteId]);

  const selectTab = (newValue) => {
    setCardStatus(newValue);
    if (newValue.value === "AutoSSL") {
      setSSLAutoData((prev) => ({
        ...prev,
        domainName: domainName,
      }));
    }
  };

  useMakeApiCalls(() => {
    if (!sites) {
      getStore().dispatch({
        type: Actions.API_GET_SELECTED_SITE_DETAILS,
        data: { siteId: siteId },
        meta: {
          onSuccess: (data) => {
            setIsPageLoading(false);
            const selectedEnvData = data.stagingDomainsList.find(
              (list) =>
                list.environment ===
                (selectedDomain?.environment === "STAGING"
                  ? "STAGING"
                  : "LIVE"),
            );
            getStore().dispatch({
              type: Actions.SET_SELECTED_DOMAIN,
              data: selectedEnvData,
            });
          },
          onError: () => {
            setIsPageLoading(false);
          },
        },
      });
    } else {
      setIsPageLoading(false);
    }

    if (!userId) {
      getStore().dispatch({
        type: Actions.API_USER_DETAILS,
      });
    }

    if (siteData?.siteName && !isEbsSite) {
      getStore().dispatch({
        type: Actions.API_SITES_LB_ARN,
        data: {
          siteName: siteData?.siteName,
        },
      });
    }

    getStore().dispatch({
      type: Actions.SET_SITE_DETAILS,
      data: {
        orgId: orgId,
        siteId: siteId,
        sitePage: lastSegment,
      },
    });
  }, [siteData]);

  const compareDomain = (domain) => {
    if (domain.slice(0, 1) === "*") {
      return domain.slice(2) === selectedDomain.domaName;
    }
    return domain === selectedDomain.domaName;
  };

  useEffect(() => {
    if (sitesInfo.sslStatus) {
      sitesInfo.sslStatus.map((domain) => {
        if (compareDomain(domain)) {
          getStore().dispatch({
            type: Actions.API_SITES_DOMAIN_SSL_STATUS,
            data: {
              siteId: siteId,
              domainId: selectedDomain.domainId,
            },
            meta: {
              onSuccess: () => {},
              onError: () => {},
            },
          });
        }
      });
    }
    // if (
    //   selectedDomain.domaName &&
    //   selectedDomain.domaName.includes(`.${process.env.REACT_APP_TEMP_DOMAIN}`)
    // ) {
    //   setSSLStatus(true);
    // }
  }, [sitesInfo.sslStatus, selectedDomain.domainId]);

  useEffect(() => {
    if (sslAuto) {
      uploadToS3();
      // getStore().dispatch({
      //   type: Actions.API_DOMAIN_SSL_STATUS,
      //   lbArn: arnInfo?.lbArn,
      // });
    }
  }, [ssldata]);

  const ActPopup = (type, id, primary) => {
    if (type === "temp-live") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Make Domain Live?",
        popupSubtitle: "Are you sure you want to bring this domain live?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setLoading(true);
          getStore().dispatch({
            type: Actions.API_MAKE_TEMP_DOMAIN_LIVE,
            data: { siteId: siteData?.siteId },
            meta: {
              onSuccess: () => {
                getStore().dispatch({
                  type: Actions.API_GET_SELECTED_SITE_DETAILS,
                  data: { siteId: siteId },
                });
                setPopup(false);
                setLoading(false);
              },
              onError: () => {
                setLoading(false);
              },
            },
          });
        },
      });
    } else if (type === "delete") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Delete Domain?",
        popupSubtitle:
          "Are you sure you want to delete this domain? This action cannot be undone.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setLoading(true);
          if (primary) {
            setLoading(false);
            ActivatePopup("warn-primary", setPopup);
          } else {
            getStore().dispatch({
              type: Actions.API_DELETE_DOMAIN,
              data: {
                siteId: siteData?.siteId,
                domainId: id,
                lbArn: isEbsSite ? undefined : arnInfo?.lbArn,
              },
              meta: {
                onSuccess: () => {
                  setLoading(false);
                  ActPopup("success-del");
                  getStore().dispatch({
                    type: Actions.API_GET_USER_NOTIFICATIONS,
                  });
                  getStore().dispatch({
                    type: Actions.API_GET_SELECTED_SITE_DETAILS,
                    data: { siteId: siteId },
                  });
                },
                onError: () => {
                  setLoading(false);
                  ActivatePopup("error-del", setPopup);
                },
              },
            });
          }
        },
      });
    } else if (type === "success-del") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Domain Deleted Successfully",
        popupSubtitle:
          "The selected domain has been permanently removed from your env.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  const inProgressDomain = siteData?.domain?.find(
    (d) => d.status === "IN_PROGRESS",
  );

  const handleGoLive = (domainName, domainId, renew) => {
    flushState();
    if (inProgressDomain) {
      ActivatePopup(
        "domain-add-in-progress",
        setPopup,
        null,
        inProgressDomain?.name,
      );
      return;
    }

    setSelectedDomain({
      domaName: domainName,
      domainId: domainId,
    });

    setSSLAutoData({
      email: emailId,
      domainName: domainName,
    });

    setSSLAutoDataErr({
      email: false,
      domainName: false,
    });

    if (renew) {
      navigate(`/account/${orgId}/${siteId}/domains-hosted?status=add-ssl`);
    } else {
      navigate(
        `/account/${orgId}/${siteId}/domains-hosted?status=point-your-domain`,
      );
    }
  };

  const getDNSStatus = (isPrimary) =>
    isPrimary ? (
      <Grid2 className={styles.check}>
        <CheckCircleIcon className={styles.checkcolor} />
        <Grid2 className={styles.font}>Active</Grid2>
      </Grid2>
    ) : (
      <Grid2 className={styles.cancel}>
        <CancelIcon className={styles.cancelcolor} />
        <Grid2 className={styles.font}>In Active</Grid2>
      </Grid2>
    );

  const getSSLStatus = (isSSLActive) =>
    isSSLActive ? (
      <Grid2 className={styles.check}>
        <CheckCircleIcon className={styles.checkcolor} />
        <Grid2 className={styles.font}>Active</Grid2>
      </Grid2>
    ) : (
      <Grid2 className={styles.cancel}>
        <CancelIcon className={styles.cancelcolor} />
        <Grid2 className={styles.font}>In Active</Grid2>
      </Grid2>
    );

  const handleAddNewDomain = () => {
    if (inProgressDomain) {
      ActivatePopup(
        "domain-add-in-progress",
        setPopup,
        null,
        inProgressDomain?.name,
      );
      return;
    }
    if (siteData?.domain && siteData?.domain?.length >= 5) {
      ActivatePopup("error", (popupState) => setPopup(popupState));
    } else {
      // setPopupCard("domain");
      navigate(
        `/account/${orgId}/${siteId}/domains-hosted?status=domain-details`,
      );
    }
  };

  const checkAndSetDomainValue = (val) => {
    val = val.toLowerCase();
    setDomainName(val);
    if (
      !Regex.domain.test(val) ||
      val.includes(`.${process.env.REACT_APP_TEMP_DOMAIN}`)
    ) {
      setDomainError(true);
    } else {
      setDomainError(false);
    }
  };

  const flushState = () => {
    setPrivateKeyError(false);
    setCertificateChainError(false);

    setSslData({
      privateKey: "",
      certificateChain: "",
    });
    setSSLAutoDataErr({ email: false });
    setSSLAutoData({ email: "", domainName: domaName });
    setTos(false);
    setShowReadyPage(false);
    setShowFailedPage(false);
    setShowPointYourDomain(false);
  };

  const flushStateVariables = () => {
    setDomainName(null);
    setDomainError(false);
    setLoading(false);
    setPopupCard(false);
    setErrorMessage("");
    flushState();
  };

  const flushVaribales = () => {
    setDomainError(false);
    setLoading(false);
    setPopupCard(false);
    setErrorMessage("");
    flushState();
  };

  const handleDomainAPI = () => {
    setDomainAPI(true);
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_CREATE_DOMAIN,
      data: {
        siteId: siteData.siteId,
        domainName: domainName,
      },
      meta: {
        onSuccess: (res) => {
          const newDomainId = res?.domainId;
          setSelectedDomain({
            domaName: domainName,
            domainId: newDomainId,
          });
          getStore().dispatch({
            type: Actions.API_GET_SELECTED_SITE_DETAILS,
            data: { siteId: siteId },
          });
          const showRecords = () => {
            setStep(2);
            setLoading(false);
            navigate(
              `/account/${orgId}/${siteId}/domains-hosted?status=point-your-domain`,
            );
            flushVaribales();
            setDomainAPI(false);
          };
          // v2: the records come from ACM; load them before the step is shown
          if (isEbsSite) {
            loadEbsDomains(showRecords);
          } else {
            showRecords();
          }
        },
        onError: (errorData) => {
          setLoading(false);
          setDomainAPI(false);
          const errorMsg =
            errorData?.errorMessage ||
            "Current domain name is already owned by someone";
          setErrorMessage(errorMsg);
        },
      },
    });
  };

  const getS3PresignedUrl = () => {
    const filename = formatFilename();
    // call redux action to get presigned url
    getStore().dispatch({
      type: Actions.API_S3_SIGNED_URL,
      fileName: filename,
      meta: {},
    });
  };

  const checkSSLData = ({ type }) => {
    var res = false;
    switch (type) {
      case "SSL_UPLOAD":
        if (ssldata.privateKey !== "" && ssldata.certificateChain !== "") {
          setPrivateKeyError(false);
          setCertificateChainError(false);
          res = true;
        } else {
          setPrivateKeyError(ssldata.privateKey === "");
          setCertificateChainError(ssldata.certificateChain === "");
        }
        break;
      case "SSL_AUTO":
        if (verifyEmail(sslAutoData.email) && sslAutoData.domainName !== "") {
          setSSLAutoDataErr({ email: false, domainName: false });
          res = true;
        } else {
          setSSLAutoDataErr({
            email: !verifyEmail(sslAutoData.email),
            domainName: sslAutoData.domainName === "",
          });
        }
        break;
      default:
        break;
    }
    return res;
  };

  const uploadToS3 = async () => {
    setLoading(true);
    setSslAuto(false);
    const fileData = {
      privateKey: ssldata.privateKey,
      certificateChain: ssldata.certificateChain,
      domainName:
        siteData.installType === "Multisite Subdomain"
          ? `*.${selectedDomain.domaName}`
          : selectedDomain.domaName,
      userId: userId,
      domainType: siteData.domainType,
      domainId: selectedDomain.domainId,
      siteName: siteData?.siteName,
      siteId: Number(siteId),
      orgId: Number(orgId),
    };
    getStore().dispatch({
      type: Actions.API_SSL_HANDLER,
      data: fileData,
      meta: {
        onSuccess: () => {
          setStep(4);
          setLoading(false);
          setTimeout(() => {
            getStore().dispatch({
              type: Actions.API_GET_SELECTED_SITE_DETAILS,
              data: { siteId: siteId },
              meta: {
                onSuccess: (data) => {
                  getStore().dispatch({
                    type: Actions.API_SITES_LB_ARN,
                    data: {
                      siteName: data.siteName,
                      siteId: data.siteId,
                    },
                  });
                },
              },
            });
          }, 4000);
        },
        onError: (errorMessage) => {
          setLoading(false);
          setShowFailedPage(true);
          setFailedMessage(errorMessage || "Failed to upload SSL certificate.");
        },
      },
    });
    // const options = {
    //   header: {
    //     "Access-Control-Allow-Origin": "*",
    //   },
    // };
    // await axios
    //   .put(
    //     sitesInfo?.selectedSite?.s3SignedUrl,
    //     JSON.stringify(fileData),
    //     options
    //   )
    // .then(() => {
    //   setLoading(false);
    //   setTimeout(() => {
    //     getStore().dispatch({
    //       type: Actions.API_GET_SELECTED_SITE_DETAILS,
    //       data: { siteId: siteId },
    //       meta: {
    //         onSuccess: (data) => {
    //           getStore().dispatch({
    //             type: Actions.API_SITES_LB_ARN,
    //             data: {
    //               siteName: data.siteName,
    //               siteId: data.siteId,
    //             },
    //           });
    //           setPopupCard("wpoptions");
    //         },
    //       },
    //     });
    //   }, 4000);
    // })
    //   .catch((e) => {
    //     setLoading(false);
    //   });
  };

  const handleSslAutoSubmit = async ({ type }) => {
    setLoading(true);

    var data = {
      type,
      email: sslAutoData.email,
      domainName: sslAutoData.domainName,
      siteId: String(siteId),
      siteName: siteData?.siteName,
      multisite: siteData.installType === "Multisite Subdomain",
      orgId,
      userId,
      domainId: selectedDomain.domainId,
      domainType: cardStatus.value === "managed",
      ...(type === "VERIFY" && {
        orderObj: sslAuthChallenge?.orderObj,
        authzObj: sslAuthChallenge?.authObj,
      }),
    };
    const options = {
      headers: {},
    };

    setLoading(true);

    if (!data.multisite) {
      // Fire-and-forget for non-multisite
      axios.post(sslAutoUrl, JSON.stringify(data), options);

      // Proceed immediately
      setLoading(false);
      setShowPointYourDomain(true);
      setStep(4);
    } else {
      // Multisite: wait for response
      try {
        const res = await axios.post(sslAutoUrl, JSON.stringify(data), options);

        if (type === "AUTH") {
          setLoading(false);
          setShowPointYourDomain(true);
          setSSLAuthChallenge(res.data.authChallenge);
        } else if (type === "VERIFY") {
          let certificate = res.data.certificateDetails.certificate.split(
            "-----BEGIN CERTIFICATE-----",
          );
          setSslAuto(true);
          setSslData({
            certificateChain: res.data.certificateDetails.certificate,
            privateKey: res.data.certificateDetails.privateKey,
          });
        }
      } catch (e) {
        setLoading(false);
        setError(true);
        setShowPointYourDomain(true);
      }
    }
  };

  // v2: a domain chosen as primary counts as primary once it is live
  const isPrimaryRow = (item) =>
    item?.primary === "Y" && (!isEbsSite || item?.status === "UPDATED");
  // v2: AWS renews through the validation CNAME; the list says when a live domain lost it
  const recordMissing = (item) => {
    const state = ebsDomainOf(item?.id)?.validationStatus;
    return state === "MISSING" || state === "FAILED";
  };
  // v2: the ACM certificate's expiry once the domain is live (AWS renews it), v1: the GCP certificate's
  const sslExpirationOf = (item) =>
    isEbsSite
      ? isPrimaryRow(item) &&
        (ebsDomainOf(item?.id)?.sslExpiration || item?.expiration)
      : item?.expiration;

  const rows = [
    {
      domain: (
        <Grid2 className={styles.domainTemp}>
          <Grid2>
            {`${siteData.siteName}.${process.env.REACT_APP_TEMP_DOMAIN}`}
          </Grid2>
          <Grid2 className={styles.temp}>Temporary</Grid2>
        </Grid2>
      ),
      DNS: getDNSStatus(
        isEbsSite
          ? !siteData?.domain?.some(isPrimaryRow)
          : siteData?.domain?.some((item) => item?.primary === "N") ||
              siteData?.domain?.length === 0,
      ),
      SSL: getSSLStatus(
        isEbsSite
          ? !siteData?.domain?.some(isPrimaryRow)
          : siteData?.domain?.some((item) => item?.primary === "N") ||
              siteData?.domain?.length === 0,
      ),
      SSLExpiration: (
        <Grid2 className={styles.none}>
          <Grid2>none</Grid2>
        </Grid2>
      ),
      primary: siteData?.domain?.some(isPrimaryRow) ? (
        <Grid2
          className={styles.goliveButton}
          onClick={() => {
            ActPopup("temp-live");
          }}
        >
          Go Live
        </Grid2>
      ) : null,
    },
    ...(siteData?.domain?.map((item) => ({
      domain: (
        <Grid2 className={styles.primary}>
          <Grid2>{item?.name}</Grid2>
          {isPrimaryRow(item) ? (
            <Grid2 className={styles.primaryBox}>Primary</Grid2>
          ) : (
            ""
          )}
        </Grid2>
      ),
      primary:
        !isPrimaryRow(item) ? (
          <Grid2
            className={styles.goliveButton}
            onClick={() => {
              if (isEbsSite && item?.status === "UPDATED") {
                installInstanceDomain(item?.id);
              } else {
                handleGoLive(item?.name, item?.id, false);
              }
              // getS3PresignedUrl();
            }}
          >
            Go Live
          </Grid2>
        ) : isEbsSite ? (
          recordMissing(item) ? (
            <Grid2
              className={styles.goliveButton}
              onClick={() => handleGoLive(item?.name, item?.id, false)}
            >
              Verify
            </Grid2>
          ) : null
        ) : (
          <Grid2
            className={styles.goliveButton}
            onClick={() => {
              handleGoLive(item?.name, item?.id, true);
              // getS3PresignedUrl();
            }}
          >
            Renew
          </Grid2>
        ),
      DNS: getDNSStatus(isPrimaryRow(item) && !recordMissing(item)),
      SSL: getSSLStatus(isPrimaryRow(item)),
      SSLExpiration: sslExpirationOf(item) ? (
        <Grid2 className={styles.none}>
          {getApproximateDaysUntilTimestamp(sslExpirationOf(item))} Days
        </Grid2>
      ) : (
        <Grid2 className={styles.none}>
          <Grid2>none</Grid2>
        </Grid2>
      ),
      isInProgress: item?.status === "IN_PROGRESS",
      status:
        item?.status === "IN_PROGRESS" ? (
          <Grid2>
            <Tooltip title="Domain update in progress" placement="bottom" arrow>
              <PROCESSING />
            </Tooltip>
          </Grid2>
        ) : item?.primary === "Y" && item?.status === "UPDATED" ? (
          <Grid2>
            <SUCCESS />
          </Grid2>
        ) : null,
      ...(item?.name !==
        `${siteData.siteName}.${process.env.REACT_APP_TEMP_DOMAIN} temp` && {
        delete: () => {
          inProgressDomain
            ? ActivatePopup(
                "domain-add-in-progress",
                setPopup,
                null,
                inProgressDomain?.name,
              )
            : ActPopup("delete", item?.id, item?.primary === "Y");
        },
      }),
    })) || []),
  ];

  const installInstanceDomain = (
    domainId = selectedDomain.domainId,
    onDone = () => {},
  ) => {
    setInstalling(true);
    getStore().dispatch({
      type: Actions.API_INSTALL_INSTANCE_DOMAIN,
      data: {
        siteId: siteData.siteId,
        domainId: domainId,
        userId: userId,
      },
      meta: {
        onSuccess: (res) => {
          setInstalling(false);
          flushStateVariables();
          getStore().dispatch({
            type: Actions.API_GET_SELECTED_SITE_DETAILS,
            data: { siteId: siteId },
          });
          onDone(true);
        },
        onError: (errorMessage) => {
          setInstalling(false);
          flushStateVariables();
          setFailedMessage(errorMessage || "Failed to make the domain primary.");
          onDone(false);
        },
      },
    });
  };

  return (
    <>
      {!isAddDomainPage && isPageLoading && <PageLoading />}

      {!isAddDomainPage && !isPageLoading && (
        <Grid2 className={styles.Container}>
          <Grid2 className={styles.header}>Domains Hosted</Grid2>
          {siteData.siteName && (
            <SiteHeaderCard
              name={
                selectedDomainsite?.environment === "STAGING"
                  ? selectedDomainsite.domainName
                  : siteData.siteName
              }
              domain={
                livedom?.length > 0
                  ? livedom
                  : (selectedDomainsite?.environment === "STAGING"
                      ? selectedDomainsite.domainName
                      : siteData.siteName) +
                    "." +
                    process.env.REACT_APP_TEMP_DOMAIN
              }
              development={isStaging}
              production={getStagingEnv(siteData.staging, STAGING.LIVE)}
              phpClick={() => adminApi("php")}
              wpClick={() =>
                adminApi(
                  "wp",
                  selectedDomainsite?.environment === "STAGING"
                    ? selectedDomainsite.domainName
                    : siteData.siteName,
                  selectedDomainsite?.environment === "STAGING"
                    ? selectedDomainsite.domainName
                    : livedom?.length > 0
                      ? livedom
                      : null,
                  selectedDomainsite?.environment === "STAGING" ? true : false,
                )
              }
              domainClick={() =>
                adminApi(
                  "domain",
                  selectedDomainsite?.environment === "STAGING"
                    ? selectedDomainsite.domainName
                    : siteData.siteName,
                  selectedDomainsite?.environment === "STAGING"
                    ? selectedDomainsite.domainName
                    : livedom?.length > 0
                      ? livedom
                      : null,
                  selectedDomainsite?.environment === "STAGING" ? true : false,
                )
              }
              siteId={siteId}
              orgId={orgId}
              image={siteData?.imagePath ? siteData?.imagePath : null}
              orgInfo={organizationsInfo}
              addOnWaf={siteData.wafStatus}
              addOnPerformanceSite={siteData.performanceSite}
            />
          )}
          <DomainTable
            rows={rows}
            addDomain={handleAddNewDomain}
            addNewDomain={"Add New Domain"}
            length={sites?.siteDomainsRes?.length}
          />
        </Grid2>
      )}

      {/* <AddingDomain
        popupCard={popupCard}
        domainError={domainError}
        domainName={domainName}
        loading={loading}
        handleClick={handleClick}
        handleDomainAPI={handleDomainAPI}
        siteData={siteData}
        ActivatePopup={(type) => ActivatePopup(type, setPopup)}
        checkAndSetDomainValue={checkAndSetDomainValue}
        purchased={purchased}
        flushStateVariables={flushStateVariables}
        setPopup={setPopup}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      /> */}

      {isAddDomainPage && (
        <AddDomain
          navigate={navigate}
          step={step}
          setStep={setStep}
          orgId={orgId}
          siteId={siteId}
          domainName={domainName}
          domainError={domainError}
          loading={loading}
          handleDomainAPI={handleDomainAPI}
          siteData={siteData}
          flushStateVariables={flushStateVariables}
          checkAndSetDomainValue={checkAndSetDomainValue}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          setSslData={setSslData}
          ssldata={ssldata}
          privateKeyError={privateKeyError}
          certificateChainError={certificateChainError}
          sslAutoData={sslAutoData}
          sslAutoDataErr={sslAutoDataErr}
          setSSLAutoData={setSSLAutoData}
          tos={tos}
          setTos={setTos}
          primary={siteData?.domain?.some((item) => item?.primary === "Y")}
          uploadClick={() => {
            if (checkSSLData({ type: "SSL_UPLOAD" })) {
              uploadToS3();
            }
          }}
          autoClick={() => {
            if (checkSSLData({ type: "SSL_AUTO" }) && tos) {
              handleSslAutoSubmit({ type: "AUTH" });
            }
          }}
          cardStatus={cardStatus}
          selectTab={selectTab}
          showReadyPage={showReadyPage}
          setShowReadyPage={setShowReadyPage}
          showFailedPage={showFailedPage}
          setShowFailedPage={setShowFailedPage}
          sslAuthChallenge={sslAuthChallenge}
          data={selectedDomain.domaName}
          showPointYourDomain={showPointYourDomain}
          setShowPointYourDomain={setShowPointYourDomain}
          flushState={flushState}
          verifySsl={() => {
            setShowPointYourDomain(false);
            setStep(4);
            handleSslAutoSubmit({ type: "VERIFY" });
          }}
          domainAPI={domainAPI}
          setDomainName={setDomainName}
          showLoading={showLoading}
          setShowLoading={setShowLoading}
          isDedicated={isDedicated}
          installInstanceDomain={installInstanceDomain}
          setInstalling={setInstalling}
          installing={installing}
          failedMessage={failedMessage}
          dnsVerified={dnsVerified}
          dnsChecking={dnsChecking}
          isEbsSite={isEbsSite}
          ebsDomain={ebsDomain}
          verifyEbsDns={verifyEbsDns}
        />
      )}

      {/* <GoLive
        popupCard={popupCard}
        siteData={siteData}
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
        flushStateVariables={flushStateVariables}
        loading={loading}
        step={() => {
          setPopupCard("SSL");
        }}
      /> */}

      {/* <SSLCert
        popupCard={popupCard}
        flushStateVariables={flushStateVariables}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        setSslData={setSslData}
        ssldata={ssldata}
        privateKeyError={privateKeyError}
        certificateChainError={certificateChainError}
        sslAutoData={sslAutoData}
        sslAutoDataErr={sslAutoDataErr}
        setSSLAutoData={setSSLAutoData}

        tos={tos}
        setTos={setTos}
        view={view}
        setView={setView}
        uploadClick={() => {
          if (checkSSLData({ type: "SSL_UPLOAD" })) {
            uploadToS3();
          }
        }}
        autoClick={() => {
          if (checkSSLData({ type: "SSL_AUTO" }) && tos) {
            handleSslAutoSubmit({ type: "AUTH" });
          }
        }}
        backPopup={() => handleBackClick()}
        loading={loading}
      /> */}

      <Dns
        popupCard={popupCard}
        siteData={siteData}
        flushStateVariables={flushStateVariables}
        sslAuthChallenge={sslAuthChallenge}
        step={() => handleSslAutoSubmit({ type: "VERIFY" })}
        loading={loading}
        data={selectedDomain.domaName}
        error={error}
      />

      <WpOptions
        popupCard={popupCard}
        flushStateVariables={flushStateVariables}
        data={selectedDomain.domaName}
      />

      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        loading={loading}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}
